<button class="empathy-viewer-icon-button" [title]="tooltip" [ngClass]="[color, size, style]" [disabled]="disabled || loading" (click)="clicked.emit()">
  @if (loading) {
    <mat-spinner diameter="20" color="light"></mat-spinner>
  } @else {
    <fa-icon [icon]="icon"></fa-icon>
  }
</button>
